// extracted by mini-css-extract-plugin
export default {"home_container":"Home_home_container__cASTx"};